import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { fadeUp } from "../../utils/animations";

export default function SectionHeading({ eyebrow, title, copy, align = "center" }) {
  return (
    <motion.div {...fadeUp()}>
      <Box sx={{ maxWidth: 800, mx: align === "center" ? "auto" : 0, textAlign: align }}>
        <Typography
          variant="overline"
          sx={{ fontWeight: 700, letterSpacing: "0.18em", color: "primary.main", display: "block" }}
        >
          {eyebrow}
        </Typography>
        <Typography variant="h3" fontWeight={700} mt={1} sx={{ fontSize: { xs: "1.73rem", md: "2.3rem" } }}>
          {title}
        </Typography>
        <Typography variant="body1" color="text.secondary" mt={2} lineHeight={1.8}>
          {copy}
        </Typography>
      </Box>
    </motion.div>
  );
}